import { render } from "./entities-and-geotargeting.vue?vue&type=template&id=7cdb6aa8&ts=true"
import script from "./entities-and-geotargeting.ts?vue&type=script&lang=ts&external"
export * from "./entities-and-geotargeting.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__